module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921072649_T.422f2ae4.jpg";